export const UPDATE_BUSINESS_CLIENT_SETTINGS_STARTED = "UPDATE_BUSINESS_CLIENT_SETTINGS_STARTED"
export const UPDATE_BUSINESS_CLIENT_SETTINGS_SUCCESS = "UPDATE_BUSINESS_CLIENT_SETTINGS_SUCCESS"
export const UPDATE_BUSINESS_CLIENT_SETTINGS_FAILURE = "UPDATE_BUSINESS_CLIENT_SETTINGS_FAILURE"

export const GET_BUSINESS_CLIENT_SETTINGS_STARTED = "GET_BUSINESS_CLIENT_SETTINGS_STARTED"
export const GET_BUSINESS_CLIENT_SETTINGS_SUCCESS = "GET_BUSINESS_CLIENT_SETTINGS_SUCCESS"
export const GET_BUSINESS_CLIENT_SETTINGS_FAILURE = "GET_BUSINESS_CLIENT_SETTINGS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
